import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { Link,  NavLink } from "react-router-dom";
import AccountNav from "./AccountNav";
import { records } from "../../../services/employerJobListing";
import { payPlan as writerPlan } from "../../../services/writerPlan";
import Posts from "../../blog/Posts";
import { profileStatistic, profileChecklist, getAuthUserData } from "../../../services/user";
import CollapseMenu from ".././CollapseMenu";
import DashboardLeftPanel from "./DashboardLeftPanel";

class Account extends Component {
    state = {
        jobs: [],
        plan: {},
        welcome: false,
        collapseMenu: false,
        profileStatistic: {},
        profileChecklist: {},
        meta: this.context.state.user,
        items: [],
        togglePadding: 'mt-3'
    };

    componentDidMount() {
        if(this.context.state.user.email_verified === 'false') {
          this.setState({togglePadding: 'mt-15'});
        }
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    // meta: response.meta
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        

        // let temp = JSON.parse(localStorage.getItem("welcome"));
        // if (temp) {
        //     this.setState({ welcome: temp });
        // }

       
        // profileStatistic()
        //     .then(response => {
        //         this.context.state.updateUser(response.meta);
        //         this.setState({
        //             profileStatistic: response.data,
        //             meta: response.meta
        //         });
        //     })
        //     .catch(error => {
        //         this.context.state.handelError(error);
        //     });

        // profileChecklist()
        //     .then(response => {               
        //         this.setState({
        //             profileChecklist: response.data,                    
        //         });
        //     })
        //     .catch(error => {
        //         this.context.state.handelError(error);
        //     });
    }

    hideWelcome = () => {
        this.setState({ welcome: false });
        localStorage.setItem("welcome", JSON.stringify({ welcome: false }));
    };
    loadApplicants = (id) => {
      localStorage.setItem("loadApplicants", id)
    };
    loadWriters = (id) => {
      localStorage.setItem("loadWriters", id)
    };
    
    render() {
        const user = this.state.meta;
        //console.log(user);
        return (
            <Fragment>
                <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container employer-container">
		            	    <div className="head">
		            		    <h1 className="text-white">Welcome back,  { user.first_name }!</h1>
		            			<h2>Let's find you some great writers.</h2>
		            		</div>
							<AccountNav></AccountNav>
		            	</div>
		            </section> */}
                    <section className={`jobsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 ${this.state.togglePadding}`}>
                        <div className="container employer-container">  
                        <div className="row align-items-center justify-content-between pb-4">
                            <div className="col">
                             <h2 className="header-title">{this.context.state.user.name}</h2>
                            </div>
                            <div className="col-auto">
                                <Link
                                to={
                                "/employer/jobListing/create"
                                    }
                                className="btn btn-primary"
                                >
                                Post a New Job
                                </Link>
                            </div>
                        </div>
                            <div className="row">  
                                <div className="col-12 col-xl-8 col-md-8">
                                {this.state.profileChecklist.display == "1" ? 
								    <div className="get-started mb-5">
									    <h3 className="mb-3">Get Started With ProWriter</h3>
										<ul className="checklist">
                                            <li className={this.state.profileChecklist.complete_lesson}><a href={this.state.profileChecklist.lesson} target="_blank">Complete free course: How to Become a Freelance Writer</a></li>
											<li className={this.state.profileChecklist.complete_portfolio}><a href={`/pw/${this.context.state.user.url}`} target="_blank">Complete your portfolio</a></li>
											<li className={this.state.profileChecklist.complete_quiz}><a href="/writer/quiz" target="_blank">Pass English competency verification quiz</a></li>
											<li className={this.state.profileChecklist.complete_badge}><a href="/account/achievements">Earn your first Achievement</a></li>
                                        </ul>
									</div>
                                    : ''}
                                    {/* {user.plan_id == "1" ? 
									<div className="unlock-plus mb-5">
									    <div className="row align-items-center">
										    <div className="col-lg-2 mb-3 mb-lg-0">
											    <img className="d-block m-auto m-lg-0 pr-0 pr-lg-4" src="images/plus.png" alt="prowriter-plus"/>
											</div>
											<div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-lg-0 mb-md-3 mb-sm-0 mb-3 text-lg-left text-md-center text-sm-left text-center">
											    <p>Launch and grow your freelance writing career by upgrading to <span>ProWriter Plus.</span></p>
											</div>
											<div className="col-lg-4 col-md-12 col-sm-6 col-12">
											    <a href="/account/settings/membership" target="_blank" className="btn btn-primary d-block">Upgrade to Plus</a>
											</div>
										</div>
									</div>
                                    : ''} */}
									<div className="card text-left">
                                        <div className="card-header">
                                            <div className="col-auto p-0">
                                                <h4 className="card-header-title">
                                                My Open Job Listings
                                                </h4>
                                            </div>
                                            <div className="col-auto p-0 text-right">
                                                <Link
                                                    
                                                    className="small"
                                                    to="/employer/jobListing/"
                                                >
                                                    View all
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="table-responsive mb-0">
                                            <table className="table table-sm table-nowrap card-table dashjobListing latest-job-listing employer-account-listing">
                                            <thead>
                                                <tr>
                                                    <th>Job Title</th>
                                                    <th>Applicants</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items.length >=
                                                1 ? (
                                                    this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </td>
                                                                    
                                                                    <td>
                                                                        {item.applicants ?
                                                                        <Link 
                                                                        to={`/employer/applicants?job=${item.title}`}
                                                                        onClick={() => this.loadApplicants(item.id)}
                                                                        >{
                                                                            item.applicants
                                                                        }
                                                                        </Link>
                                                                        : item.applicants}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )
                                                ) : (
                                                    <td
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h5 className="text-muted mt-3 mb-3">
                                                            No jobs to display
                                                        </h5>
                                                        <Link
                                                            to={`/employer/jobListing/create`}
                                                            className="btn btn-primary px-5 mb-4"
                                                        >
                                                            Post a job
                                                        </Link>
                                                    </td>
                                                )}
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    <div className="card text-left">
                                        <div className="card-header">
                                            <div className="col-auto p-0">
                                                <h4 className="card-header-title">
                                                My Open Jobs
                                                </h4>
                                            </div>
                                            <div className="col-auto p-0 text-right">
                                                <Link
                                                    
                                                    className="small"
                                                    to="/employer/jobs/"
                                                >
                                                    View all
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="table-responsive mb-0">
                                        <table className="table table-sm table-nowrap card-table dashjobListing latest-job-listing employer-account-listing">
                                            <thead>
                                                <tr>
                                                    <th>Job Title</th>
                                                    <th>Writers</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items.length >=
                                                1 ? (
                                                    this.state.items.map(
                                                        (item, index) => {
                                                            if (item.writer.length > 0) {
                                                            return (
                                                                <tr>
                                                                    <td>
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                    {item.writer.length ?
                                                                        <Link 
                                                                        to={`/employer/writers?job=${item.title}`}
                                                                        onClick={() => this.loadWriters(item.id)}
                                                                        >{
                                                                            item.writer.length
                                                                        }
                                                                        </Link>
                                                                        : item.writer.length}
                                                                    </td>
                                                                </tr>
                                                            );
                                                                    }
                                                            return false;
                                                        }
                                                    )
                                                ) : (
                                                    <td
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h5 className="text-muted mt-3 mb-3">
                                                            No jobs to display
                                                        </h5>
                                                        <Link
                                                            to={`/employer/jobListing/create`}
                                                            className="btn btn-primary px-5 mb-4"
                                                        >
                                                            Post a job
                                                        </Link>
                                                    </td>
                                                )}
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
									<div className="d-md-none d-block">
									    <Posts></Posts>
									</div>
                                </div>
                                <div className="col-12 col-xl-4 col-md-4">
                                    <DashboardLeftPanel></DashboardLeftPanel>
                                </div>
                            </div>
							
                            <div className="row">
							    <div className="col-12 col-xl-12 col-md-12">
							        {this.state.collapseMenu === true ? <CollapseMenu></CollapseMenu> : ''}
								</div>
							</div>
							
                        </div>
                    </section>
				</div>
            </Fragment>
        );
    }
}
Account.contextType = AppContext;
export default Account;



// WEBPACK FOOTER //
// ./src/components/employer/account/Account.js